var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
export var CerumItemTagType;
(function (CerumItemTagType) {
    CerumItemTagType["DEFAULT"] = "DEFAULT";
    CerumItemTagType["INFO"] = "INFO";
    CerumItemTagType["SUCCESS"] = "SUCCESS";
    CerumItemTagType["WARNING"] = "WARNING";
    CerumItemTagType["ERROR"] = "ERROR";
    CerumItemTagType["TRANSPARENT"] = "TRANSPARENT";
})(CerumItemTagType || (CerumItemTagType = {}));
let CerumItemTag = class CerumItemTag extends LitElement {
    constructor() {
        super(...arguments);
        this.itemType = CerumItemTagType.DEFAULT;
        this.selected = false;
    }
    static get is() {
        return 'cerum-item-tag';
    }
    static get styles() {
        return css `
            .item-tag {
                font-size: var(--item-tag-font-size, 12px);
                background-color: var(--item-tag-background-color, #eaeaea);
                padding: var(--item-tag-padding, 6px);
                border-radius: var(--item-tag-border-radius, 4px);
                white-space: var(--item-tag-white-space, nowrap);
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: var(--item-tag-font-weight, 550);
                display: flex;
                width: var(--item-tag-width, fit-content);
                color: #333;
                gap: var(--item-tag-gap, 0px);
                cursor: pointer;
            }

            .item-tag:hover {
                background-color: #cacaca;
                transition: 300ms ease-out;
            }

            .item-tag.success {
                background-color: #e8fded;
                color: #155724;
            }

            .item-tag.success.selected {
                background-color: #8cc78b;
                color: #155724;
            }

            .item-tag.success:hover {
                background-color: #c3e6cb;
            }

            .item-tag.warning {
                background-color: #fff3cd;
                color: #634b03;
            }

            .item-tag.warning.selected {
                background-color: #ddc98d;
                color: #856404;
            }

            .item-tag.warning:hover {
                background-color: #ffe9a5;
            }

            .item-tag.error {
                background-color: #f8d7da;
                color: #721c24;
            }

            .item-tag.error.selected {
                background-color: #e4aeb4;
                color: #721c24;
            }

            .item-tag.error:hover {
                background-color: #f5c6cb;
            }

            .item-tag.info {
                background-color: #d1ecf1;
                color: #0c5460;
            }

            .item-tag.info.selected {
                background-color: #91c8d0;
                color: #0c5460;
                transition: 300ms ease;
            }

            .item-tag.info:hover {
                background-color: #bee5eb;
            }

            .item-tag.transparent {
                background-color: transparent;
                color: inherit;
                border: 1px solid;
            }
        `;
    }
    /** @override */ render() {
        return html `<span class="${this._getItemTagClasses()}">
            <slot></slot>
        </span>`;
    }
    _getItemTagClasses() {
        const classes = ['item-tag'];
        if (this.selected) {
            classes.push('selected');
        }
        switch (this.itemType) {
            case CerumItemTagType.SUCCESS:
                classes.push('success');
                break;
            case CerumItemTagType.WARNING:
                classes.push('warning');
                break;
            case CerumItemTagType.ERROR:
                classes.push('error');
                break;
            case CerumItemTagType.INFO:
                classes.push('info');
                break;
            case CerumItemTagType.TRANSPARENT:
                classes.push('transparent');
                break;
            default:
                break;
        }
        return classes.join(' ');
    }
};
CerumItemTag._deps = [];
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], CerumItemTag.prototype, "itemType", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], CerumItemTag.prototype, "selected", void 0);
CerumItemTag = __decorate([
    customElement(CerumItemTag.is)
], CerumItemTag);
export { CerumItemTag };
